import { styled } from '@mui/system';
import { Typography } from '@mui/material';

interface TextDivProps {
  isDelivery: boolean;
}

interface TextSwitcherProps {
  isDelivery: boolean;
}

const RootDiv = styled('div')({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-around',
  border: '1px solid #EAEAEA',
  backgroundColor: 'white',
  borderRadius: '20px',
  marginBottom: '16px',
});

const TextDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<TextDivProps>(({ isDelivery }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  borderRadius: '100px',
  padding: '10px 0',
  cursor: 'pointer',
  ...(isDelivery && {
    backgroundColor: '#0A7ABE',
  }),
}));

const TextSwitcher = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDelivery',
})<TextSwitcherProps>(({ isDelivery }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '0.15px',
  color: 'white',
  ...(isDelivery
    ? {
        color: 'white',
      }
    : {
        color: '#0A7ABE',
      }),
}));

export { RootDiv, TextDiv, TextSwitcher };
